/* eslint-disable react/prop-types */
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import OrderSideComponent from '../../OrderSideComponent';
import Card from '../../../components/PaymentMethods/MercadopagoForm/Card';

import withEnhancer from '.';
import withAuthGuard from '../../withAuthGuard';

import { selectClient } from '../../../global-selectors';
import { TRANSFORM_ENTITIES } from '../../../queries/actions/constants';
import { withSidecardWrapper } from '../../../components/withSidecardWrapper';
import {
  selectCurrentPaymentMethod,
  selectCurrentSubPaymentMethod,
} from '../../../queries/selectors/payment';
import { selectCurrentContentFichaPath } from '../../../queries/selectors/contents';
import { selectUserData } from '../../../queries/selectors/user';
import {
  selectReturnURLPath,
  selectCouponApply,
  selectSubscriberConfig,
} from '../../../queries/selectors/bootstrap';
import {
  getProductsToBuy,
  getSelectedPlan,
  selectShoppingCartConfig,
} from '../../../queries/selectors/shoppingCart';
import { PaymentGateways, PaymentMethods, ProductType } from '../../../enums';
import { selectCountryCode } from '../../../queries/selectors/subscriptions';
import { injectGoogleFbTags } from '../../../utils/tags';

const mapStateToProps = (state) => ({
  selectedPlan: getSelectedPlan(state),
  userData: selectUserData(state),
  client: selectClient(state),
  productsToBuy: getProductsToBuy(state),
  shoppingCart: selectShoppingCartConfig(state),
  redirectURL:
    selectReturnURLPath(state) || selectCurrentContentFichaPath(state),
  couponApply: selectCouponApply(state),
  subscriber: selectSubscriberConfig(state),
  currentPaymentMethod: selectCurrentPaymentMethod(state),
  currentSubPaymentMethod: selectCurrentSubPaymentMethod(state),
  countryCode: selectCountryCode(state),
});

const mapDispatchToProps = (dispatch, props) => ({
  transformEntities: (payload) =>
    dispatch({
      type: TRANSFORM_ENTITIES,
      payload,
    }),
  goBack: () => {
    props.history.goBack();
  },
  handleSubmit: async (data) => {
    const { products, methodId, subscriptions, addOnSubscriptions } = props;
    const {
      couponCode,
      paymentMethodType,
      paymentMethodFlow,
      paymentMethodId,
      token,
      promoSlug,
      email
    } = data;

    const country = data.country === 'OTHER' ? '' : data.country;

    const paymentInfo = {
      token,
      payer: {
        email,
      },
      paymentMethodId,
      paymentMethodType,
      paymentMethodFlow,
      country,
      ...(promoSlug && { promoSlug }),
    };

    if (couponCode) paymentInfo.couponCode = couponCode;

    let func, reqData;
    const isMainSubscriptioFake =
      props?.currentSubscription?.purchaseState?.paymentMethod ===
      PaymentMethods.ACCESS;

    if (props.currentSubscription && !isMainSubscriptioFake) {
      const plan = props.shoppingCart?.productsToBuy.find(
        (p) => p.productType === 'plan'
      );

      if (plan) {
        paymentInfo.updatePlan = [plan.productID];
        func = props.updatePlanSubscription;
        reqData = { paymentInfo, token, subscriptions, products, methodId }
      } else {
        paymentInfo.purchaseAddOns = props.shoppingCart?.productsToBuy?.map(pkg => pkg.productID);
        func = props.upgradeAddOnSubscriptions;
        reqData = { paymentInfo, addOnSubscriptions, products, token, methodId, canceledProducts: [] }
      }
    } else {
      const isOnlyAddOnPurchase = props.shoppingCart?.productsToBuy.every(product => product.productType === ProductType.ADD_ON);
      if (isOnlyAddOnPurchase) {
        paymentInfo.purchaseAddOns = props.shoppingCart?.productsToBuy?.map(pkg => pkg.productID);
        func = props.upgradeAddOnSubscriptions;
        reqData = { paymentInfo, addOnSubscriptions, products, token, methodId, canceledProducts: [] };
      } else {
        paymentInfo.productsIds = props.shoppingCart?.productsToBuy
          ?.map((product) => product.productID)
          .filter((product) => !product.isIncludedInPlan);
        func = props.sendTransaction;
        reqData = {
          paymentMethod: props.currentPaymentMethod,
          transactionType: 'SUBSCRIPTION',
          data: paymentInfo,
        };
      }
    }

    const transactionResponse = await func(reqData);

    if (transactionResponse.status !== 200) {
      throw transactionResponse;
    }

    injectGoogleFbTags(props.selectedPlan);

    return transactionResponse.body;
  },
});

const subPaymentMethodSubscription = {
  card: Card,
};

const SubPaymentFormPageSubscription = (props) => {
  const subPaymentMethodType = props.match?.params?.subPaymentMethod
    ? props.match.params.subPaymentMethod.toLowerCase()
    : 'card';
  const PaymentMethod = subPaymentMethodSubscription[subPaymentMethodType];

  return <PaymentMethod {...props} />;
};

export default compose(
  injectIntl,
  withRouter,
  withEnhancer,
  withAuthGuard({ toLoginURL: true }),
  connect(mapStateToProps, mapDispatchToProps),
  withSidecardWrapper({
    SideComponent: OrderSideComponent,
    texts: {
      title: (props) => props?.currentSubPaymentMethod?.name,
    },
  })
)(SubPaymentFormPageSubscription);
